import { render } from "./StandardDeviationBarChart.vue?vue&type=template&id=4808ff3a&ts=true"
import script from "./StandardDeviationBarChart.vue?vue&type=script&lang=ts"
export * from "./StandardDeviationBarChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__